<template>
  <v-card flat>
    <div class="table__overflow">
      <table class="datatable table">
        <thead>
          <tr>
            <th width="20%" class="text-xs-left">{{ $t('availabilities.expertsperweek.header.expert') }}</th>
            <th
              v-for="(day, i) in days" :key="i"
              width="10%"
              class="text-xs-center">
              {{ $t(`availabilities.expertsperweek.header.day.${i}`) }}
            </th>
            <th width="10%"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="availability in hoursPerWeekDay" :key="availability.id">
            <td class="text-xs-left">
              {{ availability.expert.nickname }}
            </td>
            <availability-cell
              v-for="(hour, index) in availability.hours" :key="index"
              :availabilities="availability.availabilies[index]"
              :maxHours="maxHours">
            </availability-cell>
            <td class="text-xs-right">
              <minute :value="sumHours(availability.hours) * 60 * 60" display-empty></minute>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td
              v-for="(day, i) in days" :key="i"
              class="text-xs-center">
              <minute :value="totalHoursPerDay[i] * 60 * 60" display-empty></minute>
            </td>
            <td class="text-xs-right pr-3">
              <minute :value="sumHours(totalHoursPerDay) * 60 * 60" display-empty></minute>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <v-divider></v-divider>
    <v-card-text>
      <v-layout>
        <v-flex xs4 md3 class="text-xs-center">{{ $t('availabilities.expertsperweek.notAvailable') }}</v-flex>
        <v-flex xs4 md6 class="text-xs-center slider"></v-flex>
        <v-flex xs4 md3 class="text-xs-center">{{ $t('availabilities.expertsperweek.available', { maxHour: maxHours }) }}</v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
  import { Minute } from '@/components/formatters'
  import AvailabilityCell from './AvailabilityCell.vue'
  import availabilitiesTable from '@/mixins/availabilitiesTable'
  export default {
    components: {
      Minute,
      AvailabilityCell
    },
    mixins: [availabilitiesTable],
    computed: {
      days () { return new Array(7) }
    }
  }
</script>

<style lang="stylus" scoped>
  @import "../../variables"

  thead {
    border-bottom: 1px solid $material-twelve-percent-dark;
  }

  .slider {
    border: solid 1px #ccc;
    background: linear-gradient(to right, #fff, rgb(104, 184, 107));
  }
</style>



// WEBPACK FOOTER //
// src/components/availabilities/ExpertsPerWeek.vue